// Object Injetor Service

const findQuestion = (list, key) => {
  for (let i = 0; i < list.length; i++) {
    if (i === -1) console.error('question not found');
    if (list[i].key === key) return i;
  }
  return -1;
};

export const addValidator = (template, key, name, fn, message) => {
  let questions = template.questions;
  const i = findQuestion(questions, key);
  if (questions[i]) {
    if (!questions[i].validators) questions[i].validators = {};
    questions[i].validators[name] = { fn, message };
  }
  return template;
};

export const addBtnFn = (template, key, btnFn) => {
  let questions = template.questions;
  const i = findQuestion(questions, key);
  if (questions[i]) questions[i].fn = btnFn;
  return template;
};

export const setProp = (template, key, prop, value) => {
  let questions = template.questions;
  const i = findQuestion(questions, key);
  if (questions[i]) questions[i][prop] = value;
  return template;
};

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
